import { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'hocs'
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap'
import { getUser } from 'utils/authService'
import {
  NOTIFICATIONS_FETCH_REQUESTED,
  MARKREAD_FETCH_REQUESTED,
  MARKUNREAD_FETCH_REQUESTED,
  MARKALLREAD_FETCH_REQUESTED
} from './actions'
import s from './NotificationsContainer.scss'
import cn from 'classnames'
import { FontIcon } from 'components/Dashboard/icons/FontIcon'
import isEqual from 'lodash/isEqual'
import { preventDefault, timezoneDate } from 'utils/helpers'

@withRouter
@connect(({ notifications }) => {
  return {
    notifications
  }
})
class NotificationsContainer extends Component {
  state = {
    popoverOpen: false,
    userNotifications: [],
    manualClose: false
  }

  notificationRequest = () => {
    this.props.dispatch({
      type: NOTIFICATIONS_FETCH_REQUESTED
    })
  }

  updateUserNotifications = () => {
    this.setState((state, props) => ({ userNotifications: props.notifications.userNotifications }))
  }

  componentDidMount() {
    this.notificationRequest()
  }

  updatePopoverOpen = popoverOpen => {
    this.setState({ popoverOpen })
  }

  updateManualClose = manualClose => {
    this.setState({ manualClose })
  }

  componentDidUpdate(prevProps) {
    if (this.state.popoverOpen && this.state.manualClose) {
      this.updatePopoverOpen(false)
      this.updateManualClose(false)
    }
    if (!isEqual(prevProps, this.props)) {
      this.updateUserNotifications()
      const { userNotifications } = this.props.notifications
      const userNotificationsCount = userNotifications.filter(el => !el.read).length
      this.props.updateUnreadNotifications(userNotificationsCount)
    }
  }

  toggle = () =>
    this.setState(prevState => ({
      popoverOpen: !prevState.popoverOpen
    }))

  convertDate = date => {
    const jsDate = new Date(date)
    return timezoneDate(jsDate, 'h:mm a')
  }

  markRead = userNotificationId => {
    this.props.dispatch({
      type: MARKREAD_FETCH_REQUESTED,
      payload: { userNotificationId }
    })
  }

  markUnRead = userNotificationId => {
    this.props.dispatch({
      type: MARKUNREAD_FETCH_REQUESTED,
      payload: { userNotificationId }
    })
  }

  markAllRead = e => {
    e.preventDefault()
    if (getUser()) {
      const userId = getUser().id
      this.props.dispatch({
        type: MARKALLREAD_FETCH_REQUESTED,
        payload: { userId }
      })
    }
  }

  toggleRead = (userNotificationId, isRead) => {
    if (isRead) {
      this.markUnRead(userNotificationId)
    } else {
      this.markRead(userNotificationId)
    }
  }

  navigateTo = (e, notification) => {
    preventDefault(e)
    this.setState({ popoverOpen: false }, () => this.setState({ manualClose: true }))

    if (notification.type === 'DEAL' && notification.dealId) {
      this.props.router.navigate(`/opportunities/${notification.dealId}`)
    }
    if (notification.type === 'PROPOSAL' && notification.proposalId) {
      this.props.router.navigate(`/proposals/${notification.proposalId}`)
    }
    if (notification.type === 'TASK' && notification.dealId) {
      this.props.router.navigate(`/opportunities/${notification.dealId}/tasks`)
    }
    if (notification.type === 'SETTINGS') {
      this.props.router.navigate('/admin?tab=profile')
    }
    if (notification.type === 'EVENT') {
      this.props.router.navigate('/calendar')
    }
  }

  render() {
    const typeConversion = {
      DEAL: 'FaRegHandshake',
      PROPOSAL: 'FaRegFilePowerpoint',
      TASK: 'FaClipboardCheck',
      SETTINGS: 'FaCogs',
      EVENT: 'FaCalendarAlt'
    }
    return (
      <Popover
        className={s.notificationPopover}
        placement="bottom-end"
        isOpen={this.state.popoverOpen}
        target={this.props.notificationTarget}
        toggle={this.toggle}
        trigger="legacy"
      >
        <PopoverHeader className={s.popoverHeader}>Notifications</PopoverHeader>
        <PopoverBody>
          <a href="" onClick={e => this.markAllRead(e)} className={s.markAll}>
            Mark All as Read
          </a>
          <div className={s.tableNotifications}>
            {this.state.userNotifications.map(el => (
              <div key={el.id} className={s.tableNotification}>
                <div
                  className={cn(s.updateNotification, s.notificationItem)}
                  onClick={() => this.toggleRead(el.id, el.read)}
                >
                  <FontIcon
                    icon={el.read ? 'FaRegCircle' : 'FaCircle'}
                    color="#999999"
                    size="0.8em"
                  />
                </div>
                <div className={s.notificationItem}>
                  <FontIcon
                    icon={typeConversion[el.type ? el.type : 'TASK']}
                    color="#666666"
                    size="1.4em"
                  />
                </div>
                <div className={cn(s.dateNotification, s.notificationItem, { textBold: !el.read })}>
                  {this.convertDate(el.date)}
                </div>
                <div className={cn(s.textNotification, s.notificationItem, { textBold: !el.read })}>
                  <a href="" onClick={e => this.navigateTo(e, el)}>
                    {el.notification}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </PopoverBody>
      </Popover>
    )
  }
}

export default NotificationsContainer
